module.exports = __webpack_public_path__ + "static/media/JustActMailers_MSME-01.6b108799.png";